import React from 'react';
import PropTypes from 'prop-types';
import Loader from '@/components/common/Loader';
import { LazyDialog } from '@/modules/Dialogs';
import lazyWithRetry from '@/utils/lazyWithRetry';

const BulkEditLabelsDialogContent = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "constituent-bulk-edit-labels" */
    '@/modules/BulkEdit/components/BulkEditLabelsDialogContent'
  ),
);

export default function BulkEditLabelsDialog({
  allConstituentsCount,
  allSelected,
  allowMultiSelect,
  clearSelectedItems,
  excludedItems,
  onClose,
  query,
  selectedCount,
  selectedItems,
  ...dialogProps
}) {
  const fallback = <Loader isCentered />;

  return (
    <React.Suspense fallback={fallback}>
      <LazyDialog
        scroll="paper"
        maxWidth="sm"
        fullWidth
        onClose={onClose}
        {...dialogProps}
      >
        <BulkEditLabelsDialogContent
          allConstituentsCount={allConstituentsCount}
          allSelected={allSelected}
          allowMultiSelect={allowMultiSelect}
          clearSelectedItems={clearSelectedItems}
          excludedItems={excludedItems}
          onClose={onClose}
          query={query}
          selectedCount={selectedCount}
          selectedItems={selectedItems}
        />
      </LazyDialog>
    </React.Suspense>
  );
}

BulkEditLabelsDialog.propTypes = {
  allConstituentsCount: PropTypes.number,
  allSelected: PropTypes.bool,
  allowMultiSelect: PropTypes.bool,
  clearSelectedItems: PropTypes.func,
  excludedItems: PropTypes.arrayOf(PropTypes.string),
  onClose: PropTypes.func,
  query: PropTypes.arrayOf(
    PropTypes.shape({
      city: PropTypes.string,
      constituentAgg: PropTypes.bool,
      constituentCategories: PropTypes.arrayOf(PropTypes.string),
      constituentRules: PropTypes.arrayOf(PropTypes.string),
      constituentType: PropTypes.string,
      dateType: PropTypes.string,
      displayName: PropTypes.string,
      donationPlanCadence: PropTypes.string,
      donationTypes: PropTypes.arrayOf(PropTypes.string),
      endDate: PropTypes.string,
      filterName: PropTypes.string,
      labelIds: PropTypes.arrayOf(PropTypes.string),
      labels: PropTypes.arrayOf(PropTypes.string),
      maxDonation: PropTypes.number,
      maxMinutes: PropTypes.number,
      minDonation: PropTypes.number,
      minMinutes: PropTypes.number,
      pageFrom: PropTypes.number,
      pageSize: PropTypes.number,
      queryType: PropTypes.string,
      sortBy: PropTypes.string,
      sortOrder: PropTypes.string,
      startDate: PropTypes.string,
      state: PropTypes.string,
      userIds: PropTypes.string,
    }),
  ),
  selectedCount: PropTypes.number,
  selectedItems: PropTypes.arrayOf(PropTypes.string),
};

BulkEditLabelsDialog.defaultProps = {
  allConstituentsCount: 0,
  allSelected: false,
  allowMultiSelect: false,
  clearSelectedItems: () => {},
  excludedItems: [],
  onClose: () => {},
  query: [],
  selectedCount: 0,
  selectedItems: [],
};
